module.exports = __webpack_public_path__ + "img/Drop Down Menu - Pink.7a399277.png";